import React, { useState } from 'react';
import styled from 'styled-components';
import { CaretDown } from 'phosphor-react';

/**
 * A reusable collapsible (dropdown) section component styled similarly 
 * to the existing QRCodeTypeSelector, but adapted for a clean, 
 * modern "card-like" feel.
 */
interface CollapsibleSectionProps {
  title: React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
}

export const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  children,
  defaultOpen = false,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(defaultOpen);

  return (
    <SectionContainer>
      <SectionHeader onClick={() => setIsOpen((prev) => !prev)}>
        <Title>{title}</Title>
        <CaretIcon isOpen={isOpen}>
          <CaretDown size={20} />
        </CaretIcon>
      </SectionHeader>
      {isOpen && <SectionBody>{children}</SectionBody>}
    </SectionContainer>
  );
};

const SectionContainer = styled.div`
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  margin-bottom: 1rem;
  overflow: hidden;
  transition: all 0.3s ease;
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 1rem;
  gap: 0.5rem;

  &:hover {
    background-color: #fff5f0;
    border-color: #ff6320;
  }
`;

const Title = styled.h2`
  font-size: 1rem;
  color: #1b294b;
  margin: 0;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CaretIcon = styled.div<{ isOpen: boolean }>`
  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0)')};
  transition: transform 0.3s ease;
  color: #ff6320;
`;

const SectionBody = styled.div`
  padding: 1rem;
  border-top: 1px solid #e9ecef;
`; 